import { Button } from "@material-ui/core";
import { ButtonProps } from "@material-ui/core/Button";
import * as React from "react";
import * as s from "./CardButton.styles";

interface IButtonProps extends ButtonProps {
  icon?: JSX.Element;
  label?: string;
  labelStyle?: React.CSSProperties;
  primary?: boolean;
  backgroundColor?: React.CSSProperties["backgroundColor"];
  textColor?: React.CSSProperties["color"];
  flat?: boolean;
  isIconHTMLElement?: boolean;
}

export const CardButton = (props: IButtonProps) => {
  const {
    backgroundColor,
    icon,
    textColor,
    flat,
    label,
    primary,
    isIconHTMLElement,
    ...other
  } = props;

  // font-color can be determined by multiple variables
  const color = textColor || (primary && !props.disabled && "white") || s.base.color;

  // assemble the icon, if any
  // and if icon is an html element, do not include react props like htmlColor
  const iconProps = Object.assign(
    {},
    { style: s.icon, key: "iconCloned" },
    !isIconHTMLElement ? { htmlColor: color } : {},
  );

  const clonedIcon: JSX.Element | null = !!icon ? React.cloneElement(icon, iconProps) : null;

  // assemble the styles
  const justifyContent = !!clonedIcon ? s.base.justifyContent : "center";
  const padding = !!clonedIcon ? "8px 0" : undefined;
  const style = {
    ...s.base,
    backgroundColor,
    color,
    justifyContent,
    padding,
    ...props.style,
    opacity: !props.disabled ? 1 : 0.5,
  };
  const labelStyle = { ...s.label, color, ...props.labelStyle };

  // roll the props back together
  const childProps = { ...other, style, icon: clonedIcon };
  return flat ? (
    <Button variant="text" {...childProps}>
      {clonedIcon}
      <span style={labelStyle}>{label}</span>
    </Button>
  ) : (
    <Button variant="contained" {...childProps}>
      {clonedIcon}
      <span style={labelStyle}>{label}</span>
    </Button>
  );
};
